import Service, { service } from "@ember/service";
import { i18n } from "discourse-i18n";

const CREATOR_ACCESS_TOAST_ID =
  "community-navigation-creator-access-required";

export default class CommunityNavigationNotices extends Service {
  @service erboxToasts;

  showCreatorAccessRequired() {
    this.erboxToasts.info({
      id: CREATOR_ACCESS_TOAST_ID,
      message: i18n("community_navigation.creator_access_required"),
      dismissOnRouteChange: true,
    });
  }
}
